/*global WebView*/

var initLogin = require("../util/initLogin") ;
/**
 * This interceptors deals with user session management
 *  - ajax interceptor do redirect to login on 401 responses
 *  - navigation interceptor to redirect to login if no session opened
 *  - startup interceptor to refresh user session on application startup
 */

function isPublicScreen(app){
    var currentRoutes = app._getRoutes(app._currentPosition()) ;
    if(currentRoutes.length === 3 && (
        currentRoutes[2].route === "dbadmin" ||
        currentRoutes[2].route === "safeadmin" ||
        currentRoutes[2].route === "doc-share" ||
        currentRoutes[2].route === "external-doc-form" ||
        currentRoutes[2].route === "safe-share" ||
        currentRoutes[2].route === "rfq-price" ||
        currentRoutes[2].route === "bpm-form" ||
        currentRoutes[2].route === "doc-sign-public" ||
        currentRoutes[2].route === "docs-share" ||
        currentRoutes[2].route === "activate-portal" || 
        currentRoutes[2].route === "portal-forgot-pass" || 
        currentRoutes[2].route === "portal-renew-pass" ||
        currentRoutes[2].route === "outlook-plugin" ||
        currentRoutes[2].route === "invoice-download"  ||
        currentRoutes[2].route.startsWith("custom-public")
        )
        ){
        return true ;
    }
    return false ;
}

function isPortalScreen(app){
    var currentRoutes = app._getRoutes(app._currentPosition()) ;
    if(currentRoutes.length === 3 && (
        currentRoutes[2].route === "portal" 
        )
        ){
        return true ;
    }
    return false ;
}

function isOutlookScreen(app){
    var currentRoutes = app._getRoutes(app._currentPosition()) ;
    if(currentRoutes.length === 3 && (
        currentRoutes[2].route === "outlook-plugin" 
        )
        ){
        return true ;
    }
    return false ;
}

let timer;
module.exports = [
    {   
        type: "ajax", //called on ajax responses
        interceptor: function (app, err, request, response, next) {

            // Add a timeout event to force a refresh at the end of the session duration
            clearTimeout(timer);
            timer = setTimeout(() => {
                window.location.reload();
            }, 1000*60*60*6+3000); // This is the duration of a session, taken from UserManagement.js
            // Add 3 seconds to ensure the session is expired
            
            if(isPublicScreen(app)){
                if(!isOutlookScreen(app)){
                    app.context.api.currentUser = null ;
                }
                app.context.api.publicScreen = true ;
                return next();
            }
            if ( response &&
                (
                (response.status === 401 && response.url !== "api/auth/user") || //no session error
                (response.url === "api/auth/refreshUser?" && response.response.login === "anonymous") //or anonymous user
                )
            ) {
                //user should login

                //close all waiter that will never close because we drop the response
                WebView.closeAllWaiters();

                if (app.isSuspended() === "login") {
                    //already suspended, don't do anything
                    return;
                }


                //suspend to login
                var isPortal = isPortalScreen(app) ;
                if(isPortal){
                    app.suspendNavigation("login", app.context.controllers.loginPortalController);
                }else{
                    app.suspendNavigation("login", app.context.controllers.loginController);
                }


                if (app.currentPosition) {
                    //display message to user
                    WebView.error(WebView.tr("login.disconnectLoginAgain"), function () {
                        if(isPortal){
                            app.context.controllers.loginPortalController.focusLogin();
                        } else {
                            app.context.controllers.loginController.focusLogin();
                        }
                    });
                }
                if(response.url === "api/auth/refreshUser?"){
                    next() ;
                }
                return;
            }
            next();
        }
    },
    {
        type: "navigation", //called on navigation
        interceptor: function (app, currentPosition, next){
            if(isPublicScreen(app)){
                //on public screen, OK
                if(!isOutlookScreen(app)){
                    app.context.api.currentUser = null ;
                }
                app.context.api.publicScreen = true ;
                return next();
            }

            var isPortal = isPortalScreen(app) ;
            if(app.context.api.currentUser){ 
                if(!isPortal && app.context.api.currentUser.isPortal){
                    //not a portal screen but portal user, force move to portal
                    app.navigate("/portal") ;
                    window.location.reload() ;
                    return;
                }else{
                    return next() ;
                }
            }
            
            //not logged, open the login controller
            if(isPortal){
                app.suspendNavigation("login", app.context.controllers.loginPortalController, {}) ;
            }else{
                app.suspendNavigation("login", app.context.controllers.loginController, {}) ;
            }
        }
    },
    {
        type: "startup", //called on startup
        interceptor: function (app, callback){
            if(isPublicScreen(app)){
                //on public screen, OK
                return callback();
            }

            //refresh user session from server
            app.context.api.auth.refreshUser(function(err, user){
                if(err){ 
                    //not logged will be handled by ajax interceptor
                }
                if(user){
                    initLogin(user, callback) ;
                }else{
                    callback() ;
                }
            }) ;
        }
    }
];